import moment from "moment/moment";

export class DateUtils {
  static getDateAgeInMonths(date: Date){

    const diff: any = moment(date).diff(Date.now(), "months");
    return Math.abs(diff);
  }
}
